import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Modal, Badge } from 'react-bootstrap';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('All');

  // Mock gallery images
  const galleryImages = [
    {
      id: 1,
      title: 'College Campus',
      image: 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=800&h=600&fit=crop',
      category: 'Campus'
    },
    {
      id: 2,
      title: 'Library Interior',
      image: 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=800&h=600&fit=crop',
      category: 'Infrastructure'
    },
    {
      id: 3,
      title: 'Computer Lab',
      image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=800&h=600&fit=crop',
      category: 'Infrastructure'
    },
    {
      id: 4,
      title: 'Sports Day',
      image: 'https://images.unsplash.com/photo-1546519638-68e109498ffc?w=800&h=600&fit=crop',
      category: 'Events'
    },
    {
      id: 5,
      title: 'Cultural Festival',
      image: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=800&h=600&fit=crop',
      category: 'Events'
    },
    {
      id: 6,
      title: 'Seminar Hall',
      image: 'https://images.unsplash.com/photo-1589652717521-10c0d092dea9?w=800&h=600&fit=crop',
      category: 'Infrastructure'
    },
    {
      id: 7,
      title: 'Students in Classroom',
      image: 'https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=800&h=600&fit=crop',
      category: 'Campus'
    },
    {
      id: 8,
      title: 'Laboratory Equipment',
      image: 'https://images.unsplash.com/photo-1532094349884-543bc11b234d?w=800&h=600&fit=crop',
      category: 'Infrastructure'
    },
    {
      id: 9,
      title: 'Graduation Ceremony',
      image: 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=800&h=600&fit=crop',
      category: 'Events'
    }
  ];

  const categories = ['All', 'Campus', 'Infrastructure', 'Events'];

  const filteredImages = selectedCategory === 'All' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === selectedCategory);

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const handleNext = () => {
    const currentIndex = filteredImages.findIndex(img => img.id === selectedImage.id);
    const nextIndex = (currentIndex + 1) % filteredImages.length;
    setSelectedImage(filteredImages[nextIndex]);
  };

  const handlePrevious = () => {
    const currentIndex = filteredImages.findIndex(img => img.id === selectedImage.id);
    const prevIndex = (currentIndex - 1 + filteredImages.length) % filteredImages.length;
    setSelectedImage(filteredImages[prevIndex]);
  };

  const handleKeyDown = (e) => {
    if (selectedImage) {
      if (e.key === 'ArrowRight') {
        handleNext();
      } else if (e.key === 'ArrowLeft') {
        handlePrevious();
      } else if (e.key === 'Escape') {
        setSelectedImage(null);
      }
    }
  };

  React.useEffect(() => {
    if (selectedImage) {
      document.addEventListener('keydown', handleKeyDown);
      return () => {
        document.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [selectedImage]);

  return (
    <Container className="py-5">
      <h1 className="display-4 mb-4 text-center">Photo Gallery</h1>
      <p className="lead text-center mb-5">
        Explore moments from our college life
      </p>

      {/* Category Filter */}
      <div className="mb-5 text-center">
        {categories.map((category) => (
          <Button
            key={category}
            variant={selectedCategory === category ? 'primary' : 'outline-primary'}
            className="me-2 mb-2"
            onClick={() => setSelectedCategory(category)}
          >
            {category}
          </Button>
        ))}
      </div>

      {/* Gallery Grid */}
      <Row>
        {filteredImages.map((image) => (
          <Col key={image.id} lg={4} md={6} className="mb-4">
            <Card className="h-100 shadow-sm card-hover">
              <div 
                style={{ 
                  height: '250px', 
                  overflow: 'hidden',
                  cursor: 'pointer'
                }}
                onClick={() => handleImageClick(image)}
              >
                <img
                  src={image.image}
                  alt={image.title}
                  className="img-fluid"
                  style={{ 
                    width: '100%', 
                    height: '100%',
                    objectFit: 'cover',
                    transition: 'transform 0.3s'
                  }}
                  onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                  onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                />
              </div>
              <Card.Body>
                <Card.Title>{image.title}</Card.Title>
                <Badge bg="secondary">{image.category}</Badge>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Lightbox Modal */}
      <Modal 
        show={selectedImage !== null} 
        onHide={() => setSelectedImage(null)}
        size="lg"
        centered
        className="lightbox-modal"
      >
        {selectedImage && (
          <>
            <Modal.Header closeButton>
              <Modal.Title>{selectedImage.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0">
              <div style={{ position: 'relative' }}>
                <img
                  src={selectedImage.image}
                  alt={selectedImage.title}
                  style={{ width: '100%', height: 'auto', display: 'block' }}
                />
                
                {/* Navigation Buttons */}
                <Button
                  variant="light"
                  className="position-absolute top-50 start-0 translate-middle-y"
                  style={{ 
                    left: '15px',
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  onClick={handlePrevious}
                >
                  <i className="fas fa-chevron-left"></i>
                </Button>
                
                <Button
                  variant="light"
                  className="position-absolute top-50 end-0 translate-middle-y"
                  style={{ 
                    right: '15px',
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  onClick={handleNext}
                >
                  <i className="fas fa-chevron-right"></i>
                </Button>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Badge bg="secondary">{selectedImage.category}</Badge>
              <div className="ms-auto">
                <small className="text-muted">
                  {filteredImages.findIndex(img => img.id === selectedImage.id) + 1} of {filteredImages.length}
                </small>
              </div>
            </Modal.Footer>
          </>
        )}
      </Modal>

      {/* Add some custom styles */}
      <style jsx>{`
        .lightbox-modal .modal-content {
          background-color: rgba(0, 0, 0, 0.9);
          color: white;
        }
        
        .lightbox-modal .modal-header {
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }
        
        .lightbox-modal .modal-footer {
          border-top: 1px solid rgba(255, 255, 255, 0.1);
        }
        
        .lightbox-modal .btn-close {
          filter: invert(1) grayscale(100%) brightness(200%);
        }
        
        .lightbox-modal .btn-light {
          background-color: rgba(255, 255, 255, 0.2);
          border: none;
          color: white;
        }
        
        .lightbox-modal .btn-light:hover {
          background-color: rgba(255, 255, 255, 0.3);
        }
      `}</style>
    </Container>
  );
};

export default Gallery;